const _import = require('@/utils/import/_import_' + process.env.NODE_ENV)

export default [
  {
    path: '/special',
    name: 'Special',
    component: {
      template: '<div class="content-wrapper"><router-view></router-view></div>'
    },
    meta: {
      menuKey: 'special',
      showInMenu: true,
      title: 'Акции',
      roles: ['ROLE_ADMIN', 'ROLE_WAITER']
    },
    redirect: '/special',
    children: [
      {
        path: '',
        name: 'Special.list',
        component: _import('special/components/list'),
        meta: {
          menuKey: 'special',
          title: 'Список акций',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: 'create',
        name: 'Special.create',
        component: _import('special/components/create'),
        meta: {
          menuKey: 'special',
          title: 'Создание акции',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: ':id',
        name: 'Special.info',
        component: _import('special/components/info'),
        meta: {
          menuKey: 'special',
          title: 'Просмотр акции',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: ':id/edit',
        name: 'Special.edit',
        component: _import('special/components/edit'),
        meta: {
          menuKey: 'special',
          title: 'Редактирование акции',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/special/routes.js